function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 349",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 277",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 180h234v19H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5 180.5h233v18H.5z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 278",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M29 171h176v10H29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 171.5h175v9h-175z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Polygon 3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M116.5 0l70.971 34.067L205 110.614 155.886 172H77.114L28 110.614l17.528-76.547z",
  stroke: "#3c00dc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.5 1.11L46.396 34.76l-17.313 75.606L77.594 171h77.812l48.511-60.634-17.313-75.606L116.5 1.11m0-1.11l70.971 34.067L205 110.614 155.886 172H77.114L28 110.614l17.528-76.547L116.5 0z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Polygon 4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M116.5 172l-63.754-30.5L37 72.962 81.119 18h70.762L196 72.962 180.254 141.5z",
  stroke: "#3c00dc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.5 170.891l62.887-30.087 15.53-67.594L151.4 19H81.6L38.083 73.21l15.53 67.594 62.887 30.087m0 1.109l-63.754-30.502L37 72.962 81.12 18h70.76L196 72.962l-15.746 68.536L116.5 172z"
})));

function SvgGreenevoOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 199,
    viewBox: "0 0 234 199"
  }, props), _ref);
}

export default SvgGreenevoOutlinedinline;